import React from 'react'
import CountUp from 'react-countup'
import loader from "../../images/puff.svg"


function Cards(props) {
    const {recovered, confirmed, deaths,lastUpdate} = props.data
    if(!confirmed){
        return <div className="my-10 mx-auto">
            <img className="w-10 h-10 mx-auto" src={loader} alt="Loader"/>
            </div>
    }
    return (
        <div className="flex flex-col sm:flex-row justify-between flex-wrap">
            <div className="sm:w-1/3 px-2 sm:px-5 ">
                <div className=" flex flex-col p-10 rounded-lg shadow-sm bg-white my-3 border-b-8 border-blue-400">

                <div className="text-gray-700 text-2xl">
                    Infected
                </div>
                <div className="text-4xl font-bold text-gray-700">
                    <CountUp start={0} end={confirmed.value} duration={1} separator=","></CountUp>
                </div>
                <div className="font-semibold text-gray-600">
                    {new Date(lastUpdate).toDateString()}
                </div>
                </div>

            </div>
            <div className="sm:w-1/3 px-2 sm:px-5">
                <div className=" flex flex-col p-10 rounded-lg shadow-sm bg-white my-3 border-b-8 border-green-400">

                <div className="text-gray-700  text-2xl">
                    Recovered
                </div>
                <div className="text-4xl font-bold text-gray-700">
                    <CountUp start={0} end={recovered.value} duration={1} separator=","></CountUp>
                </div>
                <div className="font-semibold text-gray-600">
                    {new Date(lastUpdate).toDateString()}
                </div>
                </div>

            </div>
            <div className="sm:w-1/3 px-2 sm:px-5">
                <div className=" flex flex-col p-10 rounded-lg shadow-sm bg-white my-3 border-b-8 border-red-400">

                <div className="text-gray-700  text-2xl">
                    Deaths
                </div>
                <div className="text-4xl font-bold text-gray-700">
                    <CountUp start={0} end={deaths.value} duration={1} separator=","></CountUp>
                </div>
                <div className="font-semibold text-gray-600">
                    {new Date(lastUpdate).toDateString()}
                </div>
                </div>

            </div>
        </div>
    )
}

export default Cards
